import { useParams } from 'react-router-dom';
import { ConversationList } from '../components/messages/ConversationList';
import { ConversationView } from '../components/messages/ConversationView';
import { GroupConversationView } from '../components/messages/GroupConversationView';

export const MessagesPage = () => {
  const { userId } = useParams<{ userId?: string }>();

  return (
    <div className="max-w-6xl mx-auto">
      <div className="bg-white rounded-lg shadow overflow-hidden h-[calc(100dvh-160px)] sm:h-[600px]">
        <div className="flex h-full">
          {/* Conversations list - left side */}
          <div className={`${userId ? 'hidden md:block' : 'block'} w-full md:w-1/3 border-r overflow-y-auto`}>
            <ConversationList />
          </div>

          {/* Conversation view - right side */}
          <div className={`${userId ? 'block' : 'hidden md:block'} w-full md:w-2/3`}>
            {userId ? (
              <ConversationView />
            ) : (
              <div className="hidden md:flex items-center justify-center h-full text-gray-500">
                <div className="text-center">
                  <svg className="mx-auto h-12 w-12 text-gray-300 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                  </svg>
                  <p>Vælg en samtale</p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export const GroupMessagesPage = () => {
  const { conversationId } = useParams<{ conversationId: string }>();

  return (
    <div className="max-w-6xl mx-auto">
      <div className="bg-white rounded-lg shadow overflow-hidden h-[calc(100dvh-160px)] sm:h-[600px]">
        <div className="flex h-full">
          <div className="hidden md:block w-1/3 border-r overflow-y-auto">
            <ConversationList />
          </div>
          <div className="w-full md:w-2/3">
            {conversationId ? <GroupConversationView /> : null}
          </div>
        </div>
      </div>
    </div>
  );
};
